<template>
  <!-- 专著列表 -->
  <div>
    <p class="total">找到{{ total }}条结果</p>
    <van-list
      v-model="loading"
      :offset="50"
      :finished="finished"
      :error="error"
      :finished-text="List.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="list-box" v-if="loading || List.length > 0">
        <ZzItem
          class="list-item"
          v-for="item in List"
          :key="item.id"
          :title="item.title"
          :cover="item.other.cover"
          :author="item.periodical"
          @click.native="toDetail(item.id)"
        />
      </div>
      <noneList noneType="search" v-else />
    </van-list>
  </div>
</template>

<script>
import ZzItem from "@/views/mobileView/components/listItem/zzItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "Zz",
  components: { ZzItem, noneList },
  data() {
    return {
      Params: {
        pageNo: 0,
        pageSize: 20,
        queryParam: {
          configMap: {
            must: [
              {
                esField: "all",
                queryValue: this.$route.query.paramStr,
              },
              {
                esField: "articleType",
                queryValue: [2],
              },
            ],
          },
          otherQueryParams: {
            platformId: 1,
          },
        },
      },
      List: [],
      total: 0,
      loading: false,
      finished: false,
      error: false,
    };
  },
  methods: {
    // 触底加载
    onLoad() {
      this.Params.pageNo += 1;
      this.getSearchList();
    },
    // 详情跳转详情
    toDetail(id) {
      this.$router.push({
        name: "concentrationDetails",
        query: {
          id,
          type: 2,
        },
      });
    },
    // 获取资讯列表
    async getSearchList() {
      const resp = await this.$apis.searchServe.getEsList(this.Params);
      if (resp.resultCode == 200) {
        this.finished = resp.data.list.length < 10;
        this.List.push(...resp.data.list);
        this.total = +resp.data.total;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.total {
  text-align: center;
  font-size: 13px;
  color: #999999;
  line-height: 19px;
}
.list-box {
  margin-top: 15px;
  padding: 0 12px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  .list-item {
    border-bottom: 1px solid #eee;
  }
}
</style>
